import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const getAllCompanies = createAsyncThunk(
    'adminCompanies/getAdminCompanies',
    async () => { // Per ora non passo nessun parametro (sort, eccetera)
        const token = localStorage.getItem('ticino-wild-token');
        const url = `${process.env.REACT_APP_SERVER_BASE_URL}/companies/get-all-companies`;
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        };
        const options = {
            method: 'GET',
            headers
        };
        const response = await fetch(url, options);
        if(response.ok) {
            const result = await response.json();
            return result;
        } else {
            const error = await response.json();
            throw error
        }
    }
)

const adminCompaniesSlice = createSlice({
    name: "adminCompanies",
    initialState: {
        isLoading: false,
        error: null,
        count: null,
        data: null,
        isNeedRefresh: false,
        // sortBy
        // reverse
        // pageSize
        // page
    },
    reducers: {
        setIsNeedCompaniesRefresh: (state, action) => {
            state.isNeedRefresh = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(getAllCompanies.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(getAllCompanies.fulfilled, (state, action) => {
            state.error = null;
            state.data = action.payload.payload;
            state.count = action.payload.count;
            state.isLoading = false;
        })
        .addCase(getAllCompanies.rejected, (state, action) => {
            state.error = action.error;
            state.data = null;
            state.isLoading = false;
        })
    }
})

export const { setIsNeedCompaniesRefresh } = adminCompaniesSlice.actions;
export default adminCompaniesSlice.reducer;